import React from 'react'
import { Flex, Image } from '@chakra-ui/react'

import ama from './ama.png'
import footer from './footer.png'

export const Footer = props => (
  <Flex as='footer' padding={3} justifyContent='center' borderTopWidth='1px' {...props}>
    <Image height='50px' mr={3} src={footer} alt='Cofinanciado por: Compete 2020, Portugal 2020 e União Europeia, Fundo Social Europeu' />
    <Image height='50px' src={ama} alt='Logotipo AMA' />
  </Flex>
)

export default Footer
